import {
  ContentItem,
  GivingPage,
  HomePage,
  ResourcesPage,
  SiteSettings,
} from "./types";

export const fallbackHomePage: HomePage = {
  carouselSlides: [
    {
      imageUrl: "/assets/images/home/St George.jpg",
      altText: "St George Image",
      primaryText: "Welcome to the Church Official Website",
      secondaryText: "St. George Coptic Orthodox Church, Monee, IL",
    },
    {
      imageUrl: "/assets/images/home/Church Interior.jpg",
      altText: "Church Interior Image",
      primaryText:
        "Therefore humble yourselves under the mighty hand of God, that He may exalt you in due time",
      secondaryText: "1 Peter 5:6",
    },
    {
      imageUrl: "/assets/images/home/Church Interior Altar.jpg",
      altText: "Church Interior Altar Image",
      primaryText:
        "And it shall come to pass That whoever calls on the name of the Lord Shall be saved",
      secondaryText: "Acts 2:21",
    },
  ],
  metaTitle: "St. George Coptic Orthodox Church | Monee, IL",
  metaDescription:
    "Welcome to St. George Coptic Orthodox Church in Monee, IL. Find liturgies, sacraments, ministries, and resources for our Chicago community.",
};

const sundaySchoolHtml = `<div class="entry-content">
  <h3>Curriculum</h3>
  <p>The following materials are offered by the Southern Diocese of the Coptic Orthodox Church, North America. All materials are developed under the supervision of H. G. Bishop Yousef and are frequently reviewed and updated by the dioceses servants. At St. George Coptic Orthodox Church of Monee, IL we will follow this curriculum.</p>
  <ul>
    <li><a href="http://www.suscopts.org/ssc/" target="_blank" rel="noreferrer">Home</a></li>
    <li><a href="http://www.suscopts.org/ssc/introduction/">Introduction</a>
      <ul>
        <li><a href="http://suscopts.org/ssc/wp-content/uploads/2014/12/SSC.ppt">Curriculum Presentation</a></li>
        <li><a href="http://www.suscopts.org/ssc/users-guidelines/" target="_blank" rel="noreferrer">Users Guidelines</a></li>
        <li><a href="http://suscopts.org/ssc/wp-content/uploads/2014/12/Main.pdf">Schedule for All Grades</a></li>
      </ul>
    </li>
  </ul>
  <ul>
    <li><a href="http://www.suscopts.org/ssc/">Curriculum</a></li>
  </ul>
  <ul>
    <li><a href="http://www.suscopts.org/ssc/pre-school/">Pre-School</a></li>
    <li><a href="http://www.suscopts.org/ssc/kindergarten/" target="_blank" rel="noreferrer">Kindergarten</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-1/" target="_blank" rel="noreferrer">Grade 1</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-2/" target="_blank" rel="noreferrer">Grade 2</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-3/" target="_blank" rel="noreferrer">Grade 3</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-4/" target="_blank" rel="noreferrer">Grade 4</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-5/" target="_blank" rel="noreferrer">Grade 5</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-6/" target="_blank" rel="noreferrer">Grade 6</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-7/" target="_blank" rel="noreferrer">Grade 7</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-8/" target="_blank" rel="noreferrer">Grade 8</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-9/" target="_blank" rel="noreferrer">Grade 9</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-10/" target="_blank" rel="noreferrer">Grade 10</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-11/" target="_blank" rel="noreferrer">Grade 11</a></li>
    <li><a href="http://www.suscopts.org/ssc/grade-12/" target="_blank" rel="noreferrer">Grade 12</a></li>
    <li><a href="http://www.suscopts.org/ssc/college/" target="_blank" rel="noreferrer">College</a></li>
  </ul>
</div>`;

export const fallbackMinistries: ContentItem[] = [
  {
    title: "Ambassadors For Christ",
    slug: "ambassadors-for-christ",
    category: "ministry",
    excerpt:
      "Meets Every other Friday. Please contact Emad E. for more details.",
    bodyText:
      "Meets Every other Friday. Please contact Emad E. for more details.",
    imageUrl: "/assets/images/ministries/Ambassadors For Christ.jpg",
  },
  {
    title: "Sunday School Curriculum",
    slug: "sunday-school-curriculum",
    category: "ministry",
    bodyHtml: sundaySchoolHtml,
  },
  {
    title: "Coptic Roaring Lambs",
    slug: "coptic-roaring-lambs",
    category: "ministry",
    excerpt:
      "Coptic Roaring Lambs (CRL) is a youth ministry activity that meets every other Friday. Please contact any of the High School, Sunday School servant for more details.",
    bodyText:
      "Coptic Roaring Lambs (CRL) is a youth ministry activity that meets every other Friday. Please contact any of the High School, Sunday School servant for more details.",
  },
  {
    title: "Arabic Bible Study",
    slug: "arabic-bible-study",
    category: "ministry",
    excerpt:
      "Meets every Sunday at the church after the Holy Liturgy from 12:15 - 1:15 PM.",
    bodyText:
      "Meets every Sunday at the church after the Holy Liturgy from 12:15 - 1:15 PM.",
    imageUrl: "/assets/images/ministries/Arabic Bible Study.jpg",
  },
  {
    title: "Blessed Homes Ministry",
    slug: "blessed-homes",
    category: "ministry",
    imageUrl: "/assets/images/ministries/Blessed Homes.jpg",
  },
  {
    title: "Fellowship Ministry",
    slug: "fellowship",
    category: "ministry",
    excerpt: "Meets every Friday @ 7:30 pm at the church.",
    bodyText: "Meets every Friday @ 7:30 pm at the church.",
  },
  {
    title: "Board of Deacons",
    slug: "board-of-deacons",
    category: "ministry",
    imageUrl: "/assets/images/ministries/Board Of Deacons.jpg",
  },
  {
    title: "St. George Arabic Choir",
    slug: "st-george-arabic-choir",
    category: "ministry",
    excerpt: "Meets every Sunday from 1:15 - 2:00 PM.",
    bodyText: "Meets every Sunday from 1:15 - 2:00 PM.",
  },
  {
    title: "St. George Youth Choir",
    slug: "st-george-youth-choir",
    category: "ministry",
    excerpt: "Meets Saturdays from 5:00 - 6:00 PM.",
    bodyText: "Meets Saturdays from 5:00 - 6:00 PM.",
  },
  {
    title: "Agaphy Ministry",
    slug: "agaphy",
    category: "ministry",
    excerpt:
      "If you would like to help with preparing food and coffee after the Holy Liturgy, please contact Hanan or Mena H.",
    bodyText:
      "If you would like to help with preparing food and coffee after the Holy Liturgy, please contact Hanan or Mena H.",
  },
  {
    title: "Holy Bread Ministry",
    slug: "holy-bread",
    category: "ministry",
    excerpt:
      "Please contact Fady E. or Abouna if you would like to join one of the groups that makes the Holy Korban.",
    bodyText:
      "Please contact Fady E. or Abouna if you would like to join one of the groups that makes the Holy Korban.",
  },
  {
    title: "Mahragan",
    slug: "mahragan",
    category: "ministry",
    excerpt: "From June to the 2nd weekend of August.",
    bodyText: "From June to the 2nd weekend of August.",
    imageUrl: "/assets/images/ministries/Mahragan.jpg",
  },
  {
    title: "T.S.I Ministry",
    slug: "tsi",
    category: "ministry",
    excerpt: "T.S.I. (Truth Seekers Investigators), Church Drama Team.",
    bodyText: "T.S.I. (Truth Seekers Investigators), Church Drama Team.",
  },
  {
    title: "Church Bookstore",
    slug: "church-bookstore",
    category: "ministry",
    excerpt: "Open every Sunday after the Holy Liturgy.",
    bodyText: "Open every Sunday after the Holy Liturgy.",
  },
  {
    title: "Usher Ministry",
    slug: "usher",
    category: "ministry",
    excerpt:
      "Every Sunday during the Holy Liturgy. Please contact William G.",
    bodyText:
      "Every Sunday during the Holy Liturgy. Please contact William G.",
  },
  {
    title: "I.T. Ministry",
    slug: "it",
    category: "ministry",
    excerpt:
      "Maintain the church network, sound system, video broadcasting, and liturgy PowerPoint.",
    bodyText:
      "Maintain the church network, sound system, video broadcasting, and liturgy PowerPoint.",
  },
];

export const fallbackLatestNews: ContentItem[] = [
  // {
  //   title: "Egyptian Festival 2023",
  //   slug: "egyptian-festival-2023",
  //   category: "latestNews",
  // },
  // {
  //   title: "Arabic Online Bible Study",
  //   slug: "arabic-online-bible-study",
  //   category: "latestNews",
  //   excerpt: 'Please download "Microsoft Teams" app',
  //   bodyText: 'Please download "Microsoft Teams" app',
  // },
  // {
  //   title: "Covid-19 Church Statement",
  //   slug: "covid-19-church-statement",
  //   category: "latestNews",
  // },
];

export const fallbackSiteSettings: SiteSettings = {
  address: "4601 W. Pauling Rd., Monee, IL 60449",
  addressLink:
    "https://www.google.com/maps/place/St.+George+Coptic+Orthodox+Church/@41.3976162,-87.7228244,17z/data=!3m1!4b1!4m5!3m4!1s0x880e0fbf0a18d891:0xcf638fbdb831ab0e!8m2!3d41.3977452!4d-87.7228287",
  phone: "708-534-6003",
  email: "abouna@stgeorgechicago.org",
  missionStatement:
    '"For God so loved the world that He gave His only begotten Son, that whoever believes in Him should not perish but have everlasting life." John 3:16',
  socialLinks: {
    x: "https://twitter.com/stgeorgechicago",
    facebook: "https://www.facebook.com/stgeorgechicagocopts",
    youtube: "https://www.youtube.com/channel/UChEJfGq4Vynw3vxxyyTXshg",
    soundcloud: "https://soundcloud.com",
  },
};

export const fallbackGivingPage: GivingPage = {
  title: "Giving",
  metaTitle: "Giving | St. George Coptic Orthodox Church",
  metaDescription:
    "Give online, by mail, or in person to support St. George Coptic Orthodox Church in Monee, IL.",
  giveOnlineHeading: "Give Online",
  giveOnlineImageUrl: "/assets/images/giving/Giving-Info.jpg",
  giveOnlineImageAlt: "Giving QR-Code",
  mailHeading: "Mail",
  mailAddressLines: ["P.O. Box 250", "Monee, IL 60449"],
  inPersonHeading: "In Person at the Church",
  inPersonText:
    "Offering boxes are available at the entrance of the church",
};

export const fallbackResourcesPage: ResourcesPage = {
  title: "Coptic Hymns",
  metaTitle: "Coptic Hymns | Resources",
  metaDescription:
    "Coptic hymns and audio resources from St. George Coptic Orthodox Church in Monee, IL.",
  imageUrl: "/assets/images/resources/Coptic Hymns.jpg",
  imageAlt: "Coptic Hymns",
};
